import * as React from "react"

const HealthPage = () => "OK"

export default HealthPage
